module.exports = "/images/ambcloud-logo-notag.svg?40b637bf2945974dc5a7e3056ac36295";